// extracted by mini-css-extract-plugin
export default {"alternateProductsSection":"SuggestionModal_alternateProductsSection__9UQEI","header":"SuggestionModal_header__kN2fF","alternateProducts":"SuggestionModal_alternateProducts__HgmX-"};